module.exports = "https://static.wanderu.com/ui-react/_next/static/media/chiku-desktop.671f49fd.svg";